
<!-- <app-hrms-header></app-hrms-header> -->
<router-outlet></router-outlet>
<!-- <app-academic-footers></app-academic-footers> -->